// extracted by mini-css-extract-plugin
export default {"main":"Base_main__1JuBE","main-content":"Base_main-content__SxGdp"};